import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

const STORAGE_KEY = 'cafler.cafi.welcomeDismissed';

@Component({
  selector: 'app-cafi-welcome',
  templateUrl: './cafi-welcome.component.html',
  styleUrls: ['./cafi-welcome.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CafiWelcomeComponent {
  visible = !localStorage.getItem(STORAGE_KEY);

  constructor(private readonly router: Router) {}

  dismiss(): void {
    this.visible = false;
    localStorage.setItem(STORAGE_KEY, 'true');
  }

  goToChat(): void {
    this.dismiss();
    this.router.navigate(['/chat-ai']);
  }
}
